import { Row, Col, Card, Table, Button, Avatar, Typography, Input } from "antd";
import { PlusOutlined, SearchOutlined, ToTopOutlined } from "@ant-design/icons";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";

const { Title } = Typography;

// table code start
const columns = [
  {
    title: "USER",
    dataIndex: "name",
    key: "name",
    width: "32%",
  },

  {
    title: "ACTIVE",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "COMPANY",
    key: "company",
    dataIndex: "company",
  },
];

function Administrators() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState();

  const data = users?.map((user) => {
    return {
      key: user?.id,
      name: (
        <>
          <Avatar.Group>
            {/*<Avatar*/}
            {/*  className="shape-avatar"*/}
            {/*  shape="square"*/}
            {/*  size={40}*/}
            {/*  src={face}*/}
            {/*></Avatar>*/}
            <div className="avatar-info">
              <Title level={5}>{user?.username}</Title>
              <p>{user?.email}</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      // function: (
      //   <>
      //     <div className="author-info">
      //       <Title level={5}>Inspector</Title>
      //       <p>Premium Security</p>
      //     </div>
      //   </>
      // ),

      status: (
        <>
          <Button
            className={user?.active ? "tag-primary" : "tag-badge"}
            style={{ cursor: "auto" }}
          >
            {user?.active ? <span>TRUE</span> : <span>FALSE</span>}
          </Button>
        </>
      ),
      company: (
        <>
          <div className="ant-employed">
            <span>{user?.company}</span>
            <Link
              style={{ marginLeft: "10px", color: "#1EC8FF" }}
              to={`user/${user?.id}`}
            >
              Edit
            </Link>
          </div>
        </>
      ),
    };
  });

  const getUsers = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL+ "user/getAllUsers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setUsers(
        response.data.filter((user) => user.roles.includes("ROLE_ADMIN"))
      );
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Administrators"
              extra={
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <NavLink to="/add-user">
                    <Button type="secondary" className="tag-primary">
                      <PlusOutlined />
                      Add User
                    </Button>
                  </NavLink>
                  {/*<Input*/}
                  {/*  style={{ marginLeft: "20px" }}*/}
                  {/*  className="header-search"*/}
                  {/*  placeholder="Type here..."*/}
                  {/*  prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                {loading ? (
                  <Spinner />
                ) : (
                  <Table
                    style={{ padding: "10px" }}
                    columns={columns}
                    dataSource={data}
                    pagination={true}
                    className="ant-border-space"
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Administrators;
